import { forwardRef } from 'react'

import { Container, TextContainer } from 'components/container'
import { AnimatedFigcaption } from 'components/animated-figcaption'
import FlagOfficial from './assets/Flag_official 2.webp'
import FlagAlternative from './assets/Flag_alternative.webp'
import Color1 from './assets/Ellipse 9.webp'
import Color2 from './assets/Ellipse 10.webp'
import Color3 from './assets/Ellipse 11.webp'
import {
  Title,
  Figure,
  Description,
  Image,
  FlagColors,
  ThreadContainer,
} from './styled'

export const Flag = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <Title data-menu-title="флаги Коми">
      <TextContainer>Флаги Коми</TextContainer>
    </Title>

    <TextContainer>
      <p>
        <b>Официальный флаг</b> очень похож на сине-зелено-белый триколор,
        который использовали в 1917 году в Башкурдистане. В 1991 году его
        предлагали восстановить как национальный флаг в Башкортостане, но
        депутаты Верховного совета Коми ССР приняли этот флаг первыми.
      </p>
    </TextContainer>
    <Container>
      <Figure>
        <Image src={FlagOfficial} alt="" />
        <AnimatedFigcaption
          FigCaptionComponent={Description}
          description="Цвета расположены горизонтально – тремя полосами"
        />
      </Figure>
    </Container>

    <FlagColors>
      <div>
        <img src={Color1} alt="" />
        <h4>Синий</h4>
        <p>небо</p>
      </div>
      <div>
        <img src={Color2} alt="" />
        <h4>Зеленый</h4>
        <p>богатые таежные леса</p>
      </div>
      <div>
        <img src={Color3} alt="" />
        <h4>Белый</h4>
        <p>равенство проживающих в Коми народов, чистота снега</p>
      </div>
    </FlagColors>

    <TextContainer>
      <p>
        <b>Альтернативный флаг</b> показывает близость Коми к другим странам и
        регионам Северной Европы. Вдохновлен флагами скандинавских стран и
        некоторых финно-угорских народов (вепсов, ижоры, финнов).
      </p>
    </TextContainer>

    <ThreadContainer>
      <Container>
        <Figure className="second-flag">
          <Image src={FlagAlternative} alt="" />
          <AnimatedFigcaption
            FigCaptionComponent={Description}
            description="Зеленый скандинавский крест с белой каймой на синем полотнище"
          />
        </Figure>
      </Container>
    </ThreadContainer>
  </section>
))
